<div class="margening">
    <ng-template [ngIf]="vehicle && !condensed">
        <img [src]="vehicleImage" (error)="showMissingImage($event)" width="330" class="vehicle-image" />
        <div class="vehicle-information">
            <div class="d-flex justify-content-start">
                <p><strong>VIN:</strong>{{ vehicle.vin }}</p>
            </div>
            <div class="d-flex justify-content-start">
                <p><strong>Stock:</strong>{{ vehicle.stockNumber }}</p>
            </div>
            <div class="d-flex justify-content-start">
                <p>
                    <strong>Vehicle:</strong><span *ngIf="vehicle.year > 0">{{ vehicle.year }}</span> {{ vehicle.model }}
                    {{ vehicle.trim }}
                </p>
            </div>
        </div>
    </ng-template>

    <ng-template [ngIf]="vehicle && condensed">
        <div [ngClass]="selected ? 'selected' : undefined" (click)="vehicleSelected(vehicle)" class="vehicle-condensed" role="button">
            <img [src]="vehicleImage" (error)="showMissingImage($event)" width="125" class="vehicle-image" />
            <div class="vehicle-information">
                <div>
                    <p>
                        <b>{{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }} - ({{ vehicle.vehicleExt.status }})</b>
                    </p>
                </div>
                <div class="d-flex justify-content-start">
                    <p>
                        VIN: <b>{{ vehicle.vin }}</b>
                    </p>
                </div>
                <div class="d-flex justify-content-start">
                    <p>
                        Stock ID: <b>{{ vehicle.stockNumber }}</b>
                    </p>
                </div>

                <div class="d-flex justify-content-start">
                    <p>
                        Vehicle:
                        <b
                            ><span *ngIf="vehicle.year > 0">{{ vehicle.year }} </span>{{ vehicle.make }} {{ vehicle.model }} ({{ vehicle.vehicleExt.status }})
                            {{ vehicle.vehicleExt.bodyType }}</b
                        >
                    </p>
                </div>

                <div class="d-flex justify-content-start">
                    <p>
                        Ext:
                        <b>{{ vehicle?.vehicleExt?.exteriorColor || 'N/A' }}</b>
                    </p>
                </div>
                <div class="d-flex justify-content-start">
                    <p>
                        Int:
                        <b>{{ vehicle?.vehicleExt?.interiorColor || 'N/A' }}</b>
                    </p>
                </div>
            </div>
        </div>
    </ng-template>
</div>
